const form = document.querySelector('[data-chat-popup-enabled]');
const targetField = document.getElementById(form.dataset.chatTargetField);
const chatPopupEnabled = form.dataset.chatPopupEnabled;
const chatFieldValues = form.dataset.chatFieldValues;

window.addEventListener("onEmbeddedMessagingReady", () => {
  if (chatPopupEnabled.toLowerCase() === "true")
  {
    document.querySelector('.container--chat-wrap').style.display = 'none';
    targetField.addEventListener(`change`, () => showHideChat());
  }
  else {
    document.querySelector('.container--chat-wrap').style.display = 'flex';
  }
});

const showHideChat = () => {
  if (targetField.value !== "" && chatFieldValues.includes(targetField.value)) {
    document.querySelector('.container--chat-wrap').style.display = 'flex';
  }
  else {
    document.querySelector('.container--chat-wrap').style.display = 'none';
  }
};